module.exports = __webpack_public_path__ + "img/Article3F.39ed8502.jpg";